<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    title-text="Изменить пароль"
    success-text="Пароль изменен"
    error-text="Ошибка изменния пароля"
    cancel-btn="Отменить"
    success-btn="Изменить"
    :action="onAction"
    @closed="$emit('closed')"
  >
    <v-row dense>
      <v-col cols="12">
        <BTextFieldPassword
          ref="password"
          v-model="form.password"
          validate="required"
          label="Пароль"
          autofocus
        />
      </v-col>

      <v-col cols="12">
        <BTextFieldPassword
          v-model="form.password_repeat"
          :validate="{
            required: true,
            confirmBy: {
              field: '«Пароль»',
              value: form.password,
            },
          }"
          label="Повторите пароль"
        />
      </v-col>
    </v-row>
  </BModalConfirm>
</template>

<script>
import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import BTextFieldPassword from '@/components/forms/BTextFieldPassword.vue'


const createDefaultData = () => ({
  password: void 0,
  password_repeat: void 0,
})

export default {
  name: 'UsersModalPassword',
  components: {
    BModalConfirm,
    BTextFieldPassword,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    action: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    form: createDefaultData(),
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    onAction() {
      const payload = { password: this.form.password }
      return this.action({ payload, id: this.id })
    },
  },
}
</script>
